import { FormattedMessage } from 'react-intl';
import DocumentRequirement from '../DocumentRequirement/DocumentRequirement';
import messages from './RequirementTypes.messages';
import { TStatus } from '../NewDocUploads.types';

type TProps = {
    quantifier: number;
    quantifier_unit: string;
    status: TStatus;
    showStatus: boolean;
};

const VATReturns = ({
    quantifier,
    quantifier_unit,
    status,
    showStatus
}: TProps) => {
    return (
        <DocumentRequirement
            title={
                <FormattedMessage
                    {...messages.VATTitle}
                    values={{
                        strong: (chunks) => <strong>{chunks}</strong>,
                        quantifier: quantifier,
                        quantifier_unit: quantifier_unit
                    }}
                />
            }
            documentType="vat return"
            status={status}
            showStatus={showStatus}
        >
            <>
                <ul>
                    <li>
                        <FormattedMessage
                            {...messages.VATBulletOne}
                            values={{
                                link: (
                                    <a
                                        href="https://www.gov.uk/sign-in-vat-account"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <FormattedMessage
                                            {...messages.VATPortalLinkText}
                                        />
                                    </a>
                                )
                            }}
                        />
                    </li>
                    <li>
                        <FormattedMessage
                            {...messages.VATBulletTwo}
                            values={{
                                link: (
                                    <a
                                        href="https://assets.ctfassets.net/835lsoe3tdrh/3GcWysGZ9ssggP8xWu2h5D/f96aae350679aeb29d3c8ab808122e6b/vat_return_instructions.pdf"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <FormattedMessage
                                            {...messages.VATGuideLinkText}
                                        />
                                    </a>
                                )
                            }}
                        />
                    </li>
                </ul>
            </>
        </DocumentRequirement>
    );
};

// eslint-disable-next-line import/no-default-export
export default VATReturns;
